import { render, staticRenderFns } from "./NotificationHorarioLimite.vue?vue&type=template&id=20c59f83"
import script from "./NotificationHorarioLimite.vue?vue&type=script&lang=js"
export * from "./NotificationHorarioLimite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports